import { useMutation } from "react-query";
import axios, { AxiosError } from "axios";
import CreateTagCategoryApiRequest from "../request/CreateTagCategoryApiRequest";

const CreateTagCategoryApiService = async (
  request: CreateTagCategoryApiRequest
): Promise<boolean> => {
  const url = `/employertag/`;
  const { data } = await axios.post(url, request);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useCreateTagCategoryApiService = () =>
  useMutation<boolean, AxiosError, CreateTagCategoryApiRequest>(
    CreateTagCategoryApiService,
    {
      mutationKey: "CreateTagCategoryApiService",
    }
  );
export default useCreateTagCategoryApiService;
